// extracted by mini-css-extract-plugin
export default {"breakdowntitle":"Un","result_page":"Vn","what_are_calories":"Wn","title":"Xn","copy":"Yn","chart":"Zn","to_reach":"ao","title_wrapper":"bo","rhode_percent":"co","what_are_macro":"eo","text":"fo","img":"go","macros_wrapper":"ho","macros":"io","macro_item":"jo","value":"ko","note":"lo","btn":"mo","carbo_item":"no","faq":"oo","faq_items":"po"};
    if(module.hot) {
      // 1730991501882
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  